export default __webpack_public_path__ + "images/D7.bee356c.png";